import script from "./CustomDropDown.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDropDown.vue?vue&type=script&setup=true&lang=js"

import "./CustomDropDown.vue?vue&type=style&index=0&id=6a652c53&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a652c53"]])

export default __exports__